import ManageProgramsTable from './ManageProgramsTable';

export default ManageProgramsTable;
